import {
  TCustomField,
  TWorkspaceCustomFields,
} from 'src/app/project/modules/custom-fields/custom-fields.model';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import { TPointCustomFields } from 'src/app/project/modules/points/points.model';
import { TPointCustomField } from 'src/app/project/view-models/custom-field-response-model';
import {
  isPointFieldGroup,
  TPointFieldLayoutEntry,
  TPointFieldRowEntry,
} from '../components/organisms/PointFields';
import { readMentionIds } from './richTextValue';

export const toChangedPointCustomField = (
  field: TCustomField | undefined,
  value: string,
): TPointCustomField => {
  if (field?.type === ECustomFieldType.LIST) {
    return { idOfChosenElement: value };
  }

  return { value };
};

const readFieldValue = (changedField: TPointCustomField): string =>
  String(changedField.idOfChosenElement ?? changedField.value ?? '');

const toCustomFieldsListItem = (
  fieldId: string,
  changedField: TPointCustomField,
): TPointCustomField | null => {
  if (changedField.selectedItemIds) {
    return changedField.selectedItemIds.length > 0
      ? { customFieldTemplateId: fieldId, selectedItemIds: changedField.selectedItemIds }
      : null;
  }

  const value = readFieldValue(changedField);

  return value === '' ? null : { customFieldTemplateId: fieldId, value };
};

export const toCustomFieldsList = (
  changedPointCustomFields: TPointCustomFields,
): TPointCustomField[] =>
  Object.entries(changedPointCustomFields)
    .map(([fieldId, changedField]) => toCustomFieldsListItem(fieldId, changedField))
    .filter((item): item is TPointCustomField => item !== null);

export const collectMentionIds = (
  changedPointCustomFields: TPointCustomFields,
  workspaceCustomFields: TWorkspaceCustomFields,
): string[] => {
  const mentionIds = Object.entries(changedPointCustomFields)
    .filter(([fieldId]) => workspaceCustomFields[fieldId]?.type === ECustomFieldType.RICHTEXT)
    .flatMap(([, changedField]) => readMentionIds(readFieldValue(changedField)));

  return [...new Set(mentionIds)];
};

const isFormulaRow = (entry: TPointFieldRowEntry): boolean =>
  entry.field.type === ECustomFieldType.FORMULA;

const withoutFormulaRows = (entry: TPointFieldLayoutEntry): TPointFieldLayoutEntry | null => {
  if (!isPointFieldGroup(entry)) {
    return isFormulaRow(entry) ? null : entry;
  }

  const fields = entry.fields.filter((field) => !isFormulaRow(field));

  return fields.length > 0 ? { ...entry, fields } : null;
};

export const dropFormulaFields = (entries: TPointFieldLayoutEntry[]): TPointFieldLayoutEntry[] =>
  entries
    .map(withoutFormulaRows)
    .filter((entry): entry is TPointFieldLayoutEntry => entry !== null);

const lockSubValuesRow = (entry: TPointFieldRowEntry): TPointFieldRowEntry =>
  entry.field.subValuesActive ? { ...entry, canEdit: false } : entry;

export const lockSubValuesFields = (entries: TPointFieldLayoutEntry[]): TPointFieldLayoutEntry[] =>
  entries.map((entry) => {
    if (isPointFieldGroup(entry)) {
      return { ...entry, fields: entry.fields.map(lockSubValuesRow) };
    }

    return lockSubValuesRow(entry);
  });
